// Lib
import React from 'react';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';

// Components
import CloseButton from '../Button/CloseButton';

// Styles
import { useStyles } from './SideMenuStyles';

const SideMenu = ({ children, active, toggleSideMenu, styles, title }) => {
  const { classes } = useStyles({ styles });

  return (
    <Drawer
      className={classes.drawer}
      anchor="left"
      open={active}
      onClose={toggleSideMenu(false)}
      PaperProps={{ classes: { root: classes.root } }}
      ModalProps={{ BackdropProps: { classes: { root: classes.modal } } }}>
      <CloseButton
        className={classes.closeButton}
        onClose={toggleSideMenu(false)}
      />
      <div className={classes.content}>
        {title && (
          <Typography mb={3} variant="h1">
            {title}
          </Typography>
        )}
        {children}
      </div>
    </Drawer>
  );
};

export default SideMenu;
